module.exports = __webpack_public_path__ + "static/media/circle-up-arrow.c8103076.svg";